import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import ListItem from "@material-ui/core/ListItem";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "./StaffCard.css";
import Profile from "./Profile/Profile";
import { publicImageUrl } from "../../../../../Config/publicImageUrl";
import Address from "./Address/Address";
import Account from "./Account/Account";

class StaffCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navValue: "General",
    };
  }

  handleNav = (e, value) => {
    this.setState({
      navValue: value,
    });
  };

  showNav = (val) => {
    switch (val) {
      case "General":
        return <Profile staff={this.props.staff} />;
      case "Address":
        return <Address staff={this.props.staff} />;
      case "Account":
        return <Account staff={this.props.staff} />;
      default:
        break;
    }
  };

  render() {
    const { classes, staff } = this.props;
    return (
      <Fragment>
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
          <Paper className={classes.paper}>
            <div>
              <img
                src={`${publicImageUrl}/${staff.profileImage}`}
                alt={staff.fullName}
                style={{ width: 150, height: 150 }}
              />
            </div>
            <div style={{ fontSize: 24 }}>{staff.fullName}</div>
            <ListItem divider classes={{ divider: classes.dividerStyle }}>
              <div style={{ flexGrow: 1 }}>Gender </div>
              <div>{staff.gender}</div>
            </ListItem>
            <ListItem divider>
              <div style={{ flexGrow: 1 }}>Date of Birth </div>
              <div>{staff.dateOfBirth}</div>
            </ListItem>
            <ListItem divider>
              <div style={{ flexGrow: 1 }}>Email </div>
              <div>{staff.email}</div>
            </ListItem>
            <ListItem divider>
              <div style={{ flexGrow: 1 }}>Mobile </div>
              <div>{staff.mobileNumber}</div>
            </ListItem>
            <ListItem divider>
              <div style={{ flexGrow: 1 }}>Blood Group </div>
              <div>{staff.bloodGroup}</div>
            </ListItem>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={12} xl={8} lg={8}>
          <Paper className={classes.paper}>
            <BottomNavigation
              value={this.state.navValue}
              onChange={(e, val) => this.handleNav(e, val)}
              showLabels
              style={{
                width: "100%",
                borderRadius: 25,
                backgroundColor: "#eee",
              }}
            >
              <BottomNavigationAction
                label="General"
                value="General"
                classes={{
                  root: classes.bottomRoot,
                  selected: classes.bottom,
                  label: classes.navLabel,
                }}
              />
              <BottomNavigationAction
                label="Account"
                value="Account"
                classes={{
                  root: classes.bottomRoot,
                  selected: classes.bottom,
                  label: classes.navLabel,
                }}
              />
              <BottomNavigationAction
                label="Address"
                value="Address"
                classes={{
                  root: classes.bottomRoot,
                  selected: classes.bottom,
                  label: classes.navLabel,
                }}
              />
            </BottomNavigation>
            {this.showNav(this.state.navValue)}
          </Paper>
        </Grid>
      </Fragment>
    );
  }
}

export default withStyles(useStyles)(StaffCard);
